export default function TicketIdWithPrefix(data) {
  return (
    "#" +
    (data?.ticketId ? data?.ticketId + "-" : "") +
    (data?.isDraft ? "I" : "SR") +
    (data?.serviceRequestIndex ?? "")
  );
}
